import { Router } from '@angular/router';
import { Store, select } from '@ngrx/store';
import { Observable, of } from 'rxjs';
import { filter, map, switchMap, take } from 'rxjs/operators';
import * as fromRoot from '../reducers';

interface NavGuardUtilInterface {
  store: Store<fromRoot.AppState>;
  router: Router;
  routePath: string,
  routeErrorPath: string,
  isProgressBarEnabled: boolean,
  infoCompleted: Observable<boolean>;
}

export const navGuardUtil = ({
  store,
  router,
  routePath,
  routeErrorPath,
  isProgressBarEnabled,
  infoCompleted,
}: NavGuardUtilInterface): Observable<any> => {
  return store.pipe(
    select(fromRoot.getSessionState),
    filter(resData => resData.reservationRetrievalResp !== null || !!resData.error),
    take(1),
    switchMap(resData => {
      if (resData.error) {
        router.navigate([routeErrorPath]);
        return of(false);
      } else {
        if (!isProgressBarEnabled) {
          router.navigate([routePath]);
          return of(false);
        }

        return infoCompleted.pipe(map(isCompleted => {
          if (!isCompleted) {
            router.navigate([routePath]);
            return of(false);
          }

          return of(true);
        }));
      }
    })
  );
}
